import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { SessionResponse, StopSessionData } from './session';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private http = inject(HttpClient);

  private url = 'sessions';
  private sessionSubject = new BehaviorSubject<SessionResponse | null>(null);

  getList(query?: { [key: string]: unknown }): Observable<SessionResponse[]> {
    let params = new HttpParams();
    if (query) {
      Object.keys(query).forEach((key: string) => {
        const value = query[key];
        if (value !== undefined && value !== null) {
          params = params.append(key, <string>value);
        }
      });
    }
    return this.http.get<SessionResponse[]>(this.url, { params });
  }

  getOne(id: string): Observable<SessionResponse> {
    return this.http.get<SessionResponse>(`${this.url}/${id}`);
  }
  getOneByCard(cardNumber: string): Observable<SessionResponse | null> {
    return this.http.get<SessionResponse | null>(
      `${this.url}/card/${cardNumber}`
    );
  }

  start(
    number: string,
    spaceCategory: string,
    email?: string | null
  ): Observable<SessionResponse> {
    return this.http.post<SessionResponse>(`${this.url}/start`, {
      number,
      email: email || null,
      spaceCategory,
    });
  }

  stop(
    number: string,
    endDate?: string | null,
    isAdmin?: boolean
  ): Observable<SessionResponse> {
    let data: Partial<StopSessionData> = { number };
    if (isAdmin) data = { ...data, isAdmin };
    if (endDate) data = { ...data, endDate };
    return this.http.post<SessionResponse>(`${this.url}/stop`, {
      endDateAndNumber: data,
    });
  }
  // Emit updated session data
  updateSession(session: SessionResponse) {
    this.sessionSubject.next(session);
  }

  // Observable to be subscribed to by components interested in session updates
  get sessionUpdates(): Observable<SessionResponse | null> {
    return this.sessionSubject.asObservable();
  }
}
